export default "__VITE_ASSET__BL8kJ0Ap__"